import { Component, ElementRef, inject, NgZone, OnInit, signal, ViewChild } from '@angular/core';
import { PdfComponsnts } from '../misc/data/pdf-components';
import { GlobalConstants } from '../services/global-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { data_fields } from '../misc/interface/data';
import { DataService } from '../services/data.service';
import { PermissionHandlerService } from '../services/permission-handler.service';
import { PermissionLoaderService } from '../services/permission-loader.service';
import { CryptoService } from '../services/crypto.service';
import QRCode from 'qrcode';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-builder',
  templateUrl: './pdf-builder.component.html',
  styleUrl: './pdf-builder.component.scss'
})
export class PdfBuilderComponent implements OnInit {
  //Constants
  @ViewChild('printData') set printDataSetter(div: ElementRef | undefined) {
    if (div) {
      setTimeout(() => {
        if (this.fromService) {
          this.printServices();
        }
      }, 2000)
    }
  }

  @ViewChild('questions') set printQuestionsSetter(div: ElementRef | undefined) {
    if (div) {
      setTimeout(() => {
        if (this.fromQuestions) {
          this.printQuestions();
        }
      }, 2000)
    }
  }

  components: any = PdfComponsnts;
  allItems: any = []; // flattened array of all items
  chunkedItems: any[] = [];
  fromService: boolean = false;
  fromQuestions: boolean = false;

  indexData: any[] = [];

  sampleItem: any; // one sample to measure
  //Data Variables
  addedComponents: any[] = [];

  //Toogle Variables
  sidebarVisible: boolean = false;
  indexesCalculated: boolean = false;

  tableofItems: any;
  page_heading = "دليل الخدمات الحكومية";
  page_subheading = "المعرفة | التدريب | التطوير";

  data_type: string = "جميع الكيانات والوزارات";
  currentTypeFilter: any = "service";
  processing: boolean = false;
  data: any;
  dataitems: any;
  ou = 0;

  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");

  fieldTypes: any[] = [];

  GlobalConstants = GlobalConstants
  fileUrl = GlobalConstants.staticFilesURL;

  printableQuestions: any[] = [];
  printableQuestionCount: any[] = [];
  sampleCount = 0;

  formattedArabicDate: string = '';

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private permissionService: PermissionHandlerService,
    private permissionLoader: PermissionLoaderService,
    private cryptoService: CryptoService
  ) { }

  ngOnInit(): void {

    const date = new Date();

    const formatter = new Intl.DateTimeFormat('ar-EG', {
      year: 'numeric',
      month: 'long',
    });

    this.formattedArabicDate = formatter.format(date) + ' م'

    if (this.fieldTypes.length == 0) {
      this.fetchFieldType();
    }

    this.route.params.subscribe(e => {
      this.fromQuestions = e['from'] == 'questions';
      this.fromService = e['from'] == 'services';

      if (this.fromService) {
        this.setupServices();
      }

      if (this.fromQuestions) {
        this.setupQuestions();
      }
    });


  }

  setupQuestions() {
    const query = localStorage.getItem('print-query')
    if (query) {
      const obj = this.cryptoService.decodeObject(query);
      if (obj) {
        this.printableQuestions = obj.data;
        this.printableQuestionCount = obj.count;
      }
    }
    let sampleCount = 0;
    this.printableQuestions = this.printableQuestions.map(data => {
      if (!!data.sample && data.sample.length > 0) {
        sampleCount += 1;
      }
      return {
        ministry: data.ministry,
        data: data.data,
        sample: data.sample,
        count: data.data.length
      }
    })
    this.sampleCount = sampleCount;
    console.log('PRINTABLE Q', this.printableQuestionCount, this.printableQuestions)
  }

  setupServices() {
    // Subscribe to the route parameter changes
    this.route.queryParams.subscribe(async params => {

      this.dataitems = null;
      this.data = null;

      // Check if the 'id' parameter is present
      if (params['id']) {
        this.ou = params['id'];
      } else {
        this.ou = 0;
      }

      if (params['type']) {
        this.currentTypeFilter = params['type']
      }

      this.generateQrSvg();

      this.getPrintDataView();
    });
  }

  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get/', {
      active: true,
    });
    // console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data;
  }

  async getPrintDataView(): Promise<void> {
    try {

      this.processing = true;

      let ouid = Number(this.ou)
      let query: any;
      query = ouid != 0 ? {
        "breadcrumbs.id": ouid,
        "active": true,
        "tempInactive": false,
        "type.name": this.currentTypeFilter
      } : {
        "active": true,
        "tempInactive": false,
        "type.name": this.currentTypeFilter
      }

      if (!this.isLoggedIn) {
        let data = { signedArray: this.permissionService.payload.dataView.signedOus, unsignedArray: this.permissionService.payload.dataView.allOus }
        query.unsignedArray = data.unsignedArray;
        query.signedArray = data.signedArray;
      }

      query.content_ou = localStorage.getItem('content_ou');


      await this.dataService.postData('data/data-view', query).then((res: any) => {

        this.data = res.data?.map((currentItem: any) => {
          currentItem.fields?.sort((a: data_fields, b: data_fields) => {
            if (a.label?.priority && b.label?.priority) {
              return a.label?.priority - b.label?.priority;
            } else {
              return 0;
            }
          });

          currentItem.breadcrumbs.sort((a: any, b: any) => {
            return b.depth - a.depth;
          });
          return currentItem;
        });

        let tableofcontext: any = []

        this.data.forEach((item: any, index: number) => {

          tableofcontext.push({
            heading: item.breadcrumbs[0].label,
            heading_icon: item.breadcrumbs[0].icon,
            description: item.breadcrumbs[0].description,
            subheading: item.breadcrumbs[1] ? item.breadcrumbs[1].label : null,
            subheading_icon: item.breadcrumbs[1] ? item.breadcrumbs[1].icon : null,
            subsubheading: item.breadcrumbs[2] ? item.breadcrumbs[2].label : null,
            subsubheading_icon: item.breadcrumbs[2] ? item.breadcrumbs[2].icon : null,
            title: item.name,
            id: item.id,
            item_num: index
          })

        });

        console.log("table of context", tableofcontext)

        let output: { heading: any; heading_icon: any; description: string; subheadings: { subheading: any; subheading_icon: any; items: { subsubheading: any; subsubheading_icon: any; title: any; id: any; item_num: number }[]; }[]; }[] = []

        tableofcontext.forEach((item: any) => {
          const existingHeading = output.find((group) => group.heading === item.heading);

          if (existingHeading) {
            const existingSubheading = existingHeading.subheadings.find((subgroup) => subgroup.subheading === item.subheading);

            if (existingSubheading) {
              existingSubheading.items.push({
                subsubheading: item.subsubheading,
                subsubheading_icon: item.subsubheading_icon,
                title: item.title,
                id: item.id,
                item_num: item.item_num,
              });
            } else {
              existingHeading.subheadings.push({
                subheading: item.subheading,
                subheading_icon: item.subheading_icon,
                items: [
                  {
                    subsubheading: item.subsubheading,
                    subsubheading_icon: item.subsubheading_icon,
                    title: item.title,
                    id: item.id,
                    item_num: item.item_num,
                  },
                ],
              });
            }
          } else {
            output.push({
              heading: item.heading,
              heading_icon: item.heading_icon,
              description: item.description,
              subheadings: [
                {
                  subheading: item.subheading,
                  subheading_icon: item.subheading_icon,
                  items: [
                    {
                      subsubheading: item.subsubheading,
                      subsubheading_icon: item.subsubheading_icon,
                      title: item.title,
                      id: item.id,
                      item_num: item.item_num
                    },
                  ],
                },
              ],
            });
          }
        });

        console.log("Output:", output);

        this.tableofItems = output;
        this.processing = false;

      });

      

    } catch (e) {
      console.log(e)
    }
  }

  sortFiled(fileds: any): Array<any> {
    return fileds?.sort((a: any, b: any) => {
      if (a.label?.priority && b.label?.priority) {
        return a.label?.priority - b.label?.priority;
      } else {
        return 0;
      }
    });
  }

  getHostname(): string {
    return window.location.protocol + '//' + window.location.host;
  }

  pxToMM(height: number): number {
    const div = document.createElement("div");
    div.style.width = "1in";
    div.style.position = "absolute";
    div.style.top = "-100%";
    document.body.appendChild(div);

    const dpi = div.offsetWidth;
    document.body.removeChild(div);

    const pixels = height;
    return (pixels / 96) * 25.4;
  }

  mmToPx(mm: number): number {
    const div = document.createElement("div");
    div.style.width = "1in";
    div.style.position = "absolute";
    div.style.top = "-100%";
    document.body.appendChild(div);

    const dpi = div.offsetWidth;
    document.body.removeChild(div);

    return (mm / 25.4) * dpi;
  }


  printServices() {
    let start = 6;
    const pxMargin = 25.4;
    const pageHeight = 297;

    let data: any[] = []

    const indexPage = (document.querySelector("#index-page") as HTMLElement)
    const indexPageHeight = this.pxToMM(indexPage.offsetHeight);
    let indexPageCount = Math.ceil(indexPageHeight / pageHeight);


    if (indexPageCount > 1) {
      indexPageCount = this.adjustHeightForPagination(indexPageHeight, pageHeight, pxMargin);
    }

    console.log('INDEX P COUNT', indexPageCount, indexPageHeight, indexPage.offsetHeight);
    start += indexPageCount;
    const tempStart = start;
    let end = start;
    start += 1;

    document.querySelectorAll('#item-div').forEach((item: Element) => {
      const element = item as HTMLElement;
      let height = this.pxToMM(element.offsetHeight);

      // Calculate number of pages needed
      let numPages = Math.ceil(height / pageHeight)

      if (numPages > 1) {
        numPages = this.adjustHeightForPagination(height, pageHeight, (pxMargin / 2));
      }

      end += numPages;
      data.push({
        page: end,
        start
      });

      start = end + 1;
    });

    this.indexData = data;
    let pointer = tempStart;
    document.querySelectorAll('#item-div').forEach((item: Element) => {
      const element = item as HTMLElement;
      element.style.position = 'relative';
      const title = element.querySelector('h1')?.textContent;
      let height = this.pxToMM(element.offsetHeight);
      let numPages = Math.ceil(height / pageHeight)

      if (numPages > 1) {
        numPages = this.adjustHeightForPagination(height, pageHeight, (pxMargin / 2));
      }
      console.log('heights', height, numPages, pageHeight, pxMargin, title)

      for (let i = 1; i <= numPages; i++) {
        pointer += 1;
        const heightMarginDifPx = this.mmToPx(pageHeight - pxMargin);
        const top = i === 1 ? i * (heightMarginDifPx + 30) : i * (heightMarginDifPx + 60)
        const breakLabel = document.createElement('div');
        breakLabel.className = 'break-label';
        breakLabel.style.display = 'none';
        breakLabel.style.position = 'absolute';
        breakLabel.style.left = '40px';
        breakLabel.style.top = `${top}px`; // offset within container
        breakLabel.style.fontSize = '1rem';
        breakLabel.style.color = 'black';
        breakLabel.style.zIndex = '100';
        breakLabel.style.direction = 'rtl'
        breakLabel.textContent = `(${pointer})`;

        element.appendChild(breakLabel);
      }
    });
    this.indexesCalculated = true;
    console.log('Index Data', this.indexData)
  }

  printQuestions() {
    let start = 6;
    const pxMargin = 25.4;
    const pageHeight = 297;

    let data: any[] = []

    const indexPage = (document.querySelector("#question-index-page") as HTMLElement)
    const indexPageHeight = this.pxToMM(indexPage.offsetHeight);
    let indexPageCount = Math.ceil(indexPageHeight / pageHeight);


    if (indexPageCount > 1) {
      indexPageCount = this.adjustHeightForPagination(indexPageHeight, pageHeight, pxMargin);
    }

    start += indexPageCount;
    const tempStart = start;
    let end = start;
    start += 1;

    document.querySelectorAll('#question-content').forEach((item: Element) => {
      const element = item as HTMLElement;
      let height = this.pxToMM(element.offsetHeight);

      // Calculate number of pages needed
      let numPages = Math.ceil(height / pageHeight)

      if (numPages > 1) {
        numPages = this.adjustHeightForPagination(height, pageHeight, (pxMargin / 2));
      }

      end += numPages;
      data.push({
        page: end,
        start
      });

      start = end + 3;
    });

    this.indexData = data;
    let pointer = tempStart;
    document.querySelectorAll('#question-content').forEach((item: Element) => {
      const element = item as HTMLElement;
      element.style.position = 'relative';
      const title = element.querySelector('h1')?.textContent;
      let height = this.pxToMM(element.offsetHeight);
      let numPages = Math.ceil(height / pageHeight)

      if (numPages > 1) {
        numPages = this.adjustHeightForPagination(height, pageHeight, (pxMargin / 2));
      }
      console.log('heights', height, numPages, pageHeight, pxMargin, title)

      for (let i = 1; i <= numPages; i++) {
        pointer += 1;
        const heightMarginDifPx = this.mmToPx(pageHeight - pxMargin);
        const top = i === 1 ? i * (heightMarginDifPx + 30) : i * (heightMarginDifPx + 60)
        const breakLabel = document.createElement('div');
        breakLabel.className = 'break-label';
        breakLabel.style.display = 'none';
        breakLabel.style.position = 'absolute';
        breakLabel.style.left = '40px';
        breakLabel.style.top = `${top}px`; // offset within container
        breakLabel.style.fontSize = '1rem';
        breakLabel.style.color = 'black';
        breakLabel.style.zIndex = '100';
        breakLabel.style.direction = 'rtl'
        breakLabel.textContent = `(${pointer})`;

        element.appendChild(breakLabel);
      }

      pointer += 2;
    });
    this.indexesCalculated = true;
    console.log('Index Data', this.indexData)
  }

  adjustHeightForPagination(
    originalHeight: number,
    pageHeight: number,
    marginPx: number,
  ): number {
    let height = originalHeight;

    let prevPageCount = Math.ceil(height / pageHeight);
    height += prevPageCount * marginPx;
    let newPageCount = Math.ceil(height / pageHeight);

    // Repeat until page count stabilizes
    while (newPageCount !== prevPageCount) {
      const diff = newPageCount - prevPageCount;
      height += diff * marginPx;
      prevPageCount = newPageCount;
      newPageCount = Math.ceil(height / pageHeight);
    }

    return newPageCount;
  }

  print() {
    document.querySelectorAll('.break-label').forEach((elem: Element) => {
      (elem as HTMLDivElement).style.display = 'block'
    })
    if (this.fromService) {
      document.getElementById('print-service')?.click();
    } else if (this.fromQuestions) {
      document.getElementById('print-question')?.click();
    }


  }

  insertAfter(newNode: any, referenceNode: any) {
    if (referenceNode.parentNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
  }

  getGlobalIndex(itemIndex: number, subIndex: number, detailIndex: number): number {
    let count = 0;

    // Count all previous details before the current item
    for (let i = 0; i < itemIndex; i++) {
      for (let sub of this.tableofItems[i].subheadings) {
        count += sub.items.length;
      }
    }

    // Count all details in previous subitems of the current item
    for (let j = 0; j < subIndex; j++) {
      count += this.tableofItems[itemIndex].subheadings[j].items.length;
    }

    // Add the current detail index
    return count + detailIndex;
  }

  addBreaks(inserted: boolean, nodes: ChildNode[], container: HTMLElement, tempHeight: number, offsetInChild: number, breakDiv: HTMLElement, spacer: HTMLElement): boolean {
    for (const node of nodes) {
      if (!node.textContent) {
        continue;
      }

      if (
        node.nodeType === Node.ELEMENT_NODE &&
        ((node as HTMLElement).tagName === 'OL' || (node as HTMLElement).tagName === 'UL')
      ) {
        const listNodes = Array.from(node.childNodes);
        (node as HTMLElement).innerHTML = '';
        return this.addBreaks(inserted, listNodes, container, tempHeight, offsetInChild, breakDiv, spacer);
      }

      const wrapper = document.createElement('div');
      wrapper.style.display = 'block';
      wrapper.appendChild(node);
      container.appendChild(wrapper);

      const wrapperHeight = wrapper.offsetHeight;
      tempHeight += wrapperHeight;

      if (!inserted && tempHeight >= offsetInChild) {
        // Create page break marker
        container.insertBefore(breakDiv, wrapper);
        this.insertAfter(spacer, breakDiv);
        inserted = true;
      }
    }

    return inserted;
  }


  hasText(html: string | undefined | null): boolean {
    if (!html) {
      return false;
    }
    return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }


  getFieldType(type: any) {
    const fieldType = this.fieldTypes.find((item: any) => item._id == type);
    return fieldType ? fieldType.name : 'Unknown';
  }



    qrlink = signal('https://kgate.bc.gov.sa'); // Initial value
    qrSvgContent = signal<SafeHtml>('');
    private sanitizer = inject(DomSanitizer);
  
    generateQrSvg() {

      if(this.ou != 0) {
        this.qrlink.set(`${GlobalConstants.siteUrl}all-data-view?id=${this.ou}&type=faq`);
      } else {
        this.qrlink.set(`${GlobalConstants.siteUrl}all-data-view?type=faq`);
      }


    const link = this.qrlink();
    if (!link) {
      this.qrSvgContent.set('');
      return;
    }

    QRCode.toString(
      link,
      {
        type: 'svg',
        width: 220,
        // Customize colors (optional)
        color: {
          dark: '#1f2937', // Dark gray/text color
          light: '#ffffff' // White background
        },
        // Adding a small margin
        margin: 2
      }
    )
    .then(svgString => {
      // CRITICAL: Sanitize the raw SVG string for safe binding to innerHTML
      const safeSvg = this.sanitizer.bypassSecurityTrustHtml(svgString);
      this.qrSvgContent.set(safeSvg);
      console.log('QR Code generated successfully as SVG.');
    })
    .catch(error => {
      console.error('Error generating QR code SVG:', error);
      this.qrSvgContent.set(this.sanitizer.bypassSecurityTrustHtml(
        `<div class="text-red-500 p-4">Error: Could not generate QR code.</div>`
      ));
    });
  }
}
